import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

const groupValidation = {
  newName: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  contactsCache: service(),
  store: service(),

  model() {
    let groupModel = this.modelFor('funds.fund.groups.group');
    let record = this.store.createRecord('edit-group', {
      action: 'change-name',
      name: groupModel.group,
      newName: groupModel.group,
    });
    return Object.assign({}, groupModel, {
      record,
      changeset: new Changeset(
        record,
        lookupValidator(groupValidation),
        groupValidation,
      ),
    });
  },
});
